/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonChangeOfobject,
    JsonChangeOfobjectFromJSON,
    JsonChangeOfobjectFromJSONTyped,
    JsonChangeOfobjectToJSON,
} from './JsonChangeOfobject';

/**
 * 
 * @export
 * @interface JsonCompany
 */
export interface JsonCompany {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonCompany
     */
    allowedActions?: Array<JsonCompanyAllowedActionsEnum>;
    /**
     * 
     * @type {Array<JsonChangeOfobject>}
     * @memberof JsonCompany
     */
    changes?: Array<JsonChangeOfobject>;
    /**
     * 
     * @type {number}
     * @memberof JsonCompany
     */
    companyId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonCompany
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonCompany
     */
    createdBy?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonCompany
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonCompany
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonCompany
     */
    updatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonCompany
     */
    updatedBy?: number;
}

/**
* @export
* @enum {string}
*/
export enum JsonCompanyAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}

export function JsonCompanyFromJSON(json: any): JsonCompany {
    return JsonCompanyFromJSONTyped(json, false);
}

export function JsonCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonCompany {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'changes': !exists(json, 'changes') ? undefined : ((json['changes'] as Array<any>).map(JsonChangeOfobjectFromJSON)),
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
    };
}

export function JsonCompanyToJSON(value?: JsonCompany | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'changes': value.changes === undefined ? undefined : ((value.changes as Array<any>).map(JsonChangeOfobjectToJSON)),
        'companyId': value.companyId,
        'createdAt': value.createdAt,
        'createdBy': value.createdBy,
        'reason': value.reason,
        'title': value.title,
        'updatedAt': value.updatedAt,
        'updatedBy': value.updatedBy,
    };
}

